import React, { useEffect, useState } from "react";
import { Lock } from "lucide-react";
import { api } from "./api";

/* Le menu des saisons — ce qui permet à la console de durer plusieurs années.
   Une saison = « 2026/2027 ». Chaque écran daté (facturation, attestations) affiche
   celle qu'on a choisie ; par défaut la saison en cours, et l'ancienne reste
   consultable pour toujours. */
export function SelecteurSaison({ saison, onChange, testid = "selecteur-saison" }) {
  const [infos, setInfos] = useState(null);

  useEffect(() => {
    let vivant = true;
    api("/saisons")
      .then((d) => {
        if (!vivant) return;
        setInfos(d);
        if (!saison) onChange(d.defaut, d);
      })
      .catch(() => setInfos(null));
    return () => { vivant = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!infos) return null;
  const liste = [...new Set(infos.items.map((i) => i.saison))].sort().reverse();
  const suffixe = (s) =>
    s === infos.courante ? " · en cours" : s > infos.courante ? " · à venir" : " · terminée";

  return (
    <label className="flex items-center gap-2 text-[11px] font-semibold text-[var(--muted)]">
      Saison
      <select
        data-testid={testid}
        value={saison || infos.defaut}
        onChange={(e) => onChange(e.target.value, infos)}
        className="rounded-full border px-3 py-1.5 text-[11px] font-semibold bg-white"
        style={{ borderColor: "var(--border)", color: "var(--ink)" }}
      >
        {liste.map((s) => (
          <option key={s} value={s}>{s.replace("-", "/")}{suffixe(s)}</option>
        ))}
      </select>
    </label>
  );
}

/* Une saison terminée ne se recalcule plus : on le dit franchement, plutôt que de
   laisser l'école cliquer sur des boutons que le serveur refusera. */
export function BandeauSaisonClose({ etiquette, quoi = "Cette saison est terminée" }) {
  return (
    <div className="rounded-2xl px-5 py-4 flex items-center gap-3" data-testid="bandeau-saison-close"
      style={{ background: "#F1F5F9", border: "1px solid #CBD5E1" }}>
      <Lock size={18} style={{ color: "#475569" }} />
      <div className="text-sm" style={{ color: "#334155" }}>
        <strong>{quoi}{etiquette ? ` — ${etiquette}` : ""}.</strong>{" "}
        Consultation, impression et renvoi des documents : oui. Correction de montant,
        échelonnement ou facture à refaire : non — les montants d'une année close sont figés.
        Une facture qui n'était jamais partie peut encore être générée et envoyée (facture en
        retard), et un paiement en retard s'enregistre toujours normalement.
      </div>
    </div>
  );
}
